// extracted by mini-css-extract-plugin
export var title = "LinkedProduct-module--title--1dduA";
export var image = "LinkedProduct-module--image--3eXL-";
export var button = "LinkedProduct-module--button--pFIB0";